import { render, staticRenderFns } from "./KusDemo.vue?vue&type=template&id=151cb688"
import script from "./KusDemo.vue?vue&type=script&lang=js"
export * from "./KusDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports